import ValueX from '../types/ValueX';

export default class DoseX extends ValueX {
    static __className = 'DoseX';

    constructor(constructJson) {
        super(constructJson, 'dose', 'DoseX');
    }
}
